import { z } from 'zod';
import { APIResponseGroupSchema, SlideGroupRecord } from './SlideGroupType';
import { ProductTypeSchema } from './ProductType';
import { MagicModelSchema } from './MagicModel';
import { EditorSlideBaseSchema, StructureDataSchema } from './BaseSlide';

const UnitStructureSchema = z.object({
  children: z.array(StructureDataSchema),
  navigationMode: z.string(),
});

export const UnitSchema = z.object({
  id: z.string(),
  name: z.string(),
  version: z.string(),
  archived: z.boolean(),
  attributes: z.array(z.any()),
  changedAt: z.string(),
  changedBy: z.string(),
  createdAt: z.string(),
  createdBy: z.string(),
  bgColor: z.string(),
  complexityType: z.string(),
  contentPayloadVersion: z.number().optional(),
  members: z.array(z.any()),
  homeTimer: z.number().optional(),
  languageSupport: z.boolean().optional(),
  origin: z.enum(['retail']),
  selectedMappingTag: z.boolean().optional(),
  nfcTagIdList: z.array(MagicModelSchema).optional(),
  productType: ProductTypeSchema.optional(),
  slides: z.array(EditorSlideBaseSchema),
  slideGroups: z.array(APIResponseGroupSchema),
  structure: UnitStructureSchema,
  customer: z.string(),
  subsidiaries: z.array(z.string()),
  shelves: z.array(z.string()),
  readAccess: z.array(z.string()),
  writeAccess: z.array(z.string()),
  slideDeleteDisallowed: z.boolean().optional(),
  logicEditorEnabled: z.boolean().optional(),
});

export type Unit = z.infer<typeof UnitSchema>;
export type DerivedData = { slideGroups: SlideGroupRecord };
